import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { DateTimeService, DEFAULT_DATE_FORMAT } from 'src/services/DateTimeService';

import { IOrderItem } from '../../../providers';

import { StatusBadge } from './StatusBadge';
import { Options } from './Options';

import styles from './styles.module.scss';
import { Badge } from 'react-bootstrap';
import {
  OrderPaymentStatusToBadgeVariantMapping,
  OrderPaymentStatusToTextMapping,
} from '../../../../../orders/pages/order-view/constants';

export const OrderInformationCell = memo<IOrderItem>(
  ({
    options,
    serialNumber,
    timeZone,
    completedAt,
    title,
    remainingOptionsCount,
    statusCategory,
    statusName,
    isExternal,
    customerId,
    orderMeta,
    rejectionReason,
    pickUp,
    deliveries,
    paymentStatus,
  }) => (
    <td>
      <div className="font-regular-base">
        <Link to={`/users/${customerId}/${isExternal ? 'external-orders' : 'orders'}/${serialNumber}`}>
          {orderMeta?.drycleaningSerialNumber ? orderMeta.drycleaningSerialNumber : serialNumber}
        </Link>
        <span className={cn(styles.delimiter, 'mx-1')}>·</span>
        {title}
      </div>

      {pickUp?.startAt != null && (
        <div className="font-regular-base">
          Начало: {DateTimeService.formatTz({ date: pickUp.startAt, format: DEFAULT_DATE_FORMAT, timeZone })}
        </div>
      )}

      {deliveries?.map((d) => (
        <div className="font-regular-base">
          Возврат:
          {DateTimeService.formatTz({
            date: d.startAt,
            format: DEFAULT_DATE_FORMAT,
            timeZone,
          })}
        </div>
      ))}

      {rejectionReason && <div className="font-regular-base">Причина отказа: {rejectionReason.title}</div>}

      <StatusBadge statusCategory={statusCategory!} completedAt={completedAt}>
        {statusName}
      </StatusBadge>

      <Badge className="ml-1" variant={OrderPaymentStatusToBadgeVariantMapping[paymentStatus!]}>
        {OrderPaymentStatusToTextMapping[paymentStatus!]}
      </Badge>

      <Options options={options} otherOptionsCount={remainingOptionsCount} />
    </td>
  ),
);
